module.exports = __webpack_public_path__ + "img/kein-foto-hochgeladen.f6d18d2e.jpg";